module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid56_1080x842.55e5c31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid56_1080x842.jpg
// module id = 7iGi
// module chunks = 0